import React from 'react'
import { BASE_URL, FEMALE_DR_AVATAR, MALE_DR_AVATAR } from '../../configurations/initUrls'
import { MdOutlineAccessTime, MdOutlineAddLocationAlt, MdPhoneInTalk } from 'react-icons/md'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { FaHospitalUser } from 'react-icons/fa'
import { FaUserDoctor, FaRegClock } from 'react-icons/fa6'
import { HiArrowRight } from 'react-icons/hi2'
import FavoriteButton from '../app/publicUsers/FavoriteButton'

export default function DoctorsCard({ item, isCenter = false, center }) {
    if (!item) return null

    const primaryTo = isCenter ? `/center/${center?.id}` : `/doctor/${item.doctorId}`
    const avatar = item.isDP == 0 ? (item.gender === 0 ? MALE_DR_AVATAR : FEMALE_DR_AVATAR) : BASE_URL + "/" + item.dpUrl
    const expText = `${item.experiance} ${item.experiance > 1 ? "yrs" : "yr"} exp`

    const Row = ({ icon, children }) => (
        <span className="flex items-start gap-2 text-[13px] text-gray-600">
            <span className="mt-0.5 shrink-0">{icon}</span>
            <span className="min-w-0 break-words">{children}</span>
        </span>
    )

    return (
        <div className="group relative h-full w-full flex flex-col rounded-2xl bg-white border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 overflow-hidden animate-fade-up">
            {/* top accent */}
            <div className="h-1.5 bg-gradient-to-r from-brand-400 to-brand-600" />

            <Link to={primaryTo} className="flex-1 p-4 sm:p-5">
                {/* header */}
                <div className="flex items-center gap-3 sm:gap-4">
                    <div className="relative shrink-0">
                        <img className="h-14 w-14 sm:h-16 sm:w-16 rounded-2xl ring-2 ring-brand-100 object-cover bg-brand-50"
                            src={avatar} alt={`Dr. ${item.fullName}`} loading="lazy"
                            onError={(e) => { e.currentTarget.src = item.gender === 0 ? MALE_DR_AVATAR : FEMALE_DR_AVATAR }} />
                        <span className="absolute -bottom-1 -right-1 grid place-items-center h-6 w-6 rounded-full bg-brand-500 text-white ring-2 ring-white">
                            <FaUserDoctor className="text-[11px]" />
                        </span>
                    </div>
                    <div className="min-w-0">
                        <h3 className="font-display font-bold text-gray-900 leading-tight truncate">Dr. {item.fullName}</h3>
                        <p className="text-brand-600 text-xs sm:text-sm font-medium truncate">
                            {item.specialisation?.name}{item.specialisation?.shortName ? ` (${item.specialisation.shortName})` : ""}
                        </p>
                        {item.degree && <p className="text-gray-400 text-xs truncate">{item.degree}</p>}
                    </div>
                </div>

                {/* badges */}
                <div className="mt-3 flex flex-wrap gap-1.5">
                    <span className="chip bg-emerald-50 text-emerald-700"><FaRegClock className="text-[11px]" /> {expText}</span>
                    {isCenter && center?.centerName &&
                        <span className="chip bg-rose-50 text-rose-700 max-w-full"><FaHospitalUser className="text-[11px]" /> <span className="truncate">{center.centerName}</span></span>}
                </div>

                {/* details */}
                <div className="mt-3 space-y-1.5">
                    {isCenter ?
                        <>
                            <Row icon={<MdOutlineAccessTime className="text-lime-500 text-base" />}>
                                {moment(new Date(center.opdStartTime)).format("LT")} – {moment(new Date(center.opdEndTime)).format("LT")}
                            </Row>
                            <Row icon={<MdPhoneInTalk className="text-green-500 text-base" />}>{center.phone}</Row>
                            <Row icon={<MdOutlineAddLocationAlt className="text-blue-500 text-base" />}>{center.address}, {center.city?.name}</Row>
                        </>
                        :
                        <>
                            <Row icon={<MdPhoneInTalk className="text-green-500 text-base" />}>{item.userName}</Row>
                            <Row icon={<MdOutlineAddLocationAlt className="text-blue-500 text-base" />}>{item.address}, {item.city?.name}</Row>
                        </>
                    }
                </div>
            </Link>

            {/* CTA */}
            <div className="px-4 pb-4 sm:px-5 sm:pb-5 flex items-center justify-between gap-3">
                <Link to={`/doctor/${item.doctorId}`}
                    className="btn-blue group/btn">
                    Take Appointment
                    <HiArrowRight className="transition-transform group-hover/btn:translate-x-0.5" />
                </Link>
                <FavoriteButton item={item} />
            </div>
        </div>
    )
}